import React from 'react'
import { AppBar, Toolbar, Typography, Box } from '@mui/material'

const Header = ({ logo }) => (
  <AppBar position="static">
    <Toolbar sx={{ justifyContent: 'center' }}>
      <Typography variant="h6">Patient Record Access</Typography>
      <Box sx={{ flexGrow: 1 }} />
      <Box
        padding={0}
        borderRadius={1}
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Box
          component="img"
          src={logo}
          alt="Company Logo"
          style={{
            height: '40px',
            backgroundColor: 'white',
            padding: 2,
            borderRadius: 2,
          }}
        />
      </Box>
    </Toolbar>
  </AppBar>
)

export default Header
